import { withI18n } from 'react-i18next';

import SlideMenu from './SlideMenu';

export const pureComponent = SlideMenu;
export default withI18n()(SlideMenu);
